import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core'
import { BeneficiarySoaDetail } from '../../models/view-soa-model'
import { SearchInsertModel } from '../../models/search-soa-model'
import { ExportHistoryModel } from '../../models/export-history-model'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { ExcelService } from '../../excel.service'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import * as moment from 'moment'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { PortalGlobals } from '../../../portalglobals'
import { JqxGridVirtualPaging } from '../../../../app/common/utilclasses/jqxgrid-virtualpaging'
import * as _ from 'lodash'

@Component({
    selector: 'viewsoa',
    templateUrl: 'e-app-history.component.html',
    styleUrls: ['e-app-history.component.scss']
})
export class EAppHistoryComponent implements OnInit {
    @ViewChild('gridReference', { static: true }) myGrid: jqxGridComponent
    beneficiarySOAViewModel: BeneficiarySoaDetail[]
    viewSOAModel: BeneficiarySoaDetail
    searchInsertModel: SearchInsertModel
    beneficiaryStatus: ValidatedSelectOptionModel[]
    enrollmentViewModel: EnrollmentViewModel = {} as EnrollmentViewModel
    //  SearchInsertModel: any = { BeneficiaryName: '', BeneficaryEmail: '', AgentId: '', Status: ''}
    exportSOA: ExportHistoryModel[]
    order = 'RecCreateTS'
    reverse = false
    p = 1
    totalRec: number
    public currentUser: CurrentUser = {} as CurrentUser
    downloadError: string
    serviceResponse: string
    IsrecordFound: boolean
    showlink: boolean = false
    uniqueLink: string
    public loading: boolean = false
    skipCall: boolean
    chunkSize: number = 10000
    totalCount: number
    jqxGridVirtualPaging: JqxGridVirtualPaging
    showAgentID: boolean
    showEnrollmentButton: boolean = true

    jqx: any
    data: any = []
    source: any = {
        localdata: this.data,
        datatype: 'array',
        datafields: [
            { name: 'BeneficiaryName', type: 'string' },
            { name: 'BeneficiaryEmail', type: 'string' },
            { name: 'UserId', type: 'string' },
            { name: 'ApplicationStatus', type: 'string' },
            { name: 'RecCreateTS', type: 'date' },
            { name: 'PlanYear', type: 'number' },
            { name: 'UniqueLink', type: 'string' },
            { name: 'ConfirmationNumber', type: 'string' },
            { name: 'EnrollmentPdf', type: 'string' }
        ]
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)

    columns: any[] = [
        { text: 'Beneficiary Name', columntype: 'textbox', datafield: 'BeneficiaryName', width: 160, editable: false },
        { text: 'Beneficiary Email', columntype: 'textbox', datafield: 'BeneficiaryEmail', width: 285, editable: false },
        { text: 'Agent ID', columntype: 'textbox', datafield: 'UserId', width: 105, editable: false },
        {
            text: 'Status',
            datafield: 'ApplicationStatus',
            cellsalign: 'center',
            width: 100,
            editable: false,
            cellsRenderer: function (row, columnfield, value, id, columnData, rowData) {
                if (
                    rowData.ApplicationStatus === 'In Progress' ||
                    rowData.ApplicationStatus === 'Failed' ||
                    rowData.ApplicationStatus === 'Correction'
                ) {
                    return '<a class="link">' + rowData.ApplicationStatus + '</a>'
                } else {
                    return rowData.ApplicationStatus
                }
            }
        },
        { text: 'Date Created', datafield: 'RecCreateTS', columntype: 'textbox', width: 175, editable: false, cellsformat: 'MM/dd/yyyy h:mm tt' },
        { text: 'Plan Year', columntype: 'textbox', datafield: 'PlanYear', width: 100, editable: false },
        { text: 'Confirmation #', columntype: 'textbox', datafield: 'ConfirmationNumber', width: 150, editable: false },
        {
            text: '',
            datafield: 'EnrollmentPdf',
            cellsalign: 'center',
            width: 150,
            editable: false,
            sortable: false,
            filterable: false,
            menu: false,
            cellsRenderer: function (row, columnfield, value, id, columnData, rowData) {
                if (rowData.ApplicationStatus === 'Signed') {
                    return '<a class="link-button link download-pdf">Download</a>'
                } else {
                    return ''
                }
            }
        }
    ]

    ngOnInit() {
        this.searchInsertModel = {} as SearchInsertModel
        this.viewSOAModel = {} as BeneficiarySoaDetail
        // getting user object from session
        this.loading = true
        this.skipCall = true
        this.showAgentID = false

        this._networkUserAccessGateway.getCurrentUser().subscribe(
            (user) => {
                if (user != null) {
                    this.currentUser = user
                    if (
                        this.currentUser.isOrganizationalAdmin ||
                        this.currentUser.isOrganizationalManager ||
                        this.currentUser.UserProfileStatusCode === 'Inactive'
                    )
                        this.showEnrollmentButton = false

                    this.viewSOAModel.SenderUserID = this.currentUser.userProfileName
                    this.viewSOAModel.OrgID = this.currentUser.orgId
                    this.viewSOAModel.PageNumber = 1
                    this.viewSOAModel.PageSize = 20
                    // this.viewSOAModel.UserProfileID = this.currentUser.userProfileName
                    // this.viewSOAModel.UserID = this.currentUser.userProfileName

                    // for search
                    this.searchInsertModel.SenderUserID = this.currentUser.userProfileName
                    this.searchInsertModel.OrgID = this.currentUser.orgId
                    this.searchInsertModel.PageNumber = 1
                    this.searchInsertModel.PageSize = 20
                    this.showHideAgentID()
                    // this.searchInsertModel.UserProfileID = this.currentUser.userProfileName
                    // this.searchInsertModel.UserID = this.currentUser.userProfileName
                    if (this.currentUser.AetnaInd === true) {
                        this.enrollementGateway.loadPWEAppHistoryData(this.viewSOAModel).subscribe(
                            (model: BeneficiarySoaDetail[]) => {
                                this.processEAppHistory(model)
                            },
                            (err) => {
                                this.loading = false
                            }
                        )
                    } else {
                        this.enrollementGateway.loadEAppHistoryData(this.viewSOAModel).subscribe(
                            (model: BeneficiarySoaDetail[]) => {
                                this.processEAppHistory(model)
                            },
                            (err) => {
                                this.loading = false
                            }
                        )
                    }
                } else {
                    // already exists in session
                    this.viewSOAModel.SenderUserID = this.currentUser.userProfileName
                    this.viewSOAModel.OrgID = this.currentUser.orgId
                    this.viewSOAModel.UserProfileID = this.currentUser.userProfileName
                    this.viewSOAModel.PageNumber = 1
                    this.viewSOAModel.PageSize = 20
                    if (
                        this.currentUser.isOrganizationalAdmin ||
                        this.currentUser.isOrganizationalManager ||
                        this.currentUser.UserProfileStatusCode === 'Inactive'
                    )
                        this.showEnrollmentButton = false

                    // for search
                    this.searchInsertModel.AgentUserProfileName = this.currentUser.userProfileName
                    this.searchInsertModel.OrgID = this.currentUser.orgId
                    this.searchInsertModel.UserId = this.currentUser.userProfileName
                    this.searchInsertModel.UserProfileID = this.currentUser.userProfileName
                    this.searchInsertModel.PageNumber = 1
                    this.searchInsertModel.PageSize = 20
                    this.showHideAgentID()

                    this.showHideAgentID()
                    this.enrollementGateway.loadEAppHistoryData(this.viewSOAModel).subscribe(
                        (model: BeneficiarySoaDetail[]) => {
                            this.beneficiarySOAViewModel = model
                            model.map((row) => {
                                row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                            })
                            this.totalCount = this.source.totalrecords = this.beneficiarySOAViewModel[0].TotalCount
                            this.source.localdata = this.beneficiarySOAViewModel

                            this.dataAdapter.dataBind()
                            this.myGrid.updatebounddata()
                            this.loading = false
                            this.skipCall = false
                            console.log(this.beneficiarySOAViewModel)
                        },

                        (err) => {
                            this.loading = false
                        }
                    )
                }
            },
            (err) => {
                this.loading = false
            }
        )

        this.beneficiaryStatus = [
            {
                text: '',
                value: 'All'
            },
            {
                text: 'Signed',
                value: 'Signed'
            },
            {
                text: 'Expired',
                value: 'Expired'
            },
            {
                text: 'Viewed',
                value: 'Viewed'
            },
            {
                text: 'In Progress',
                value: 'In Progress'
            },
            {
                text: 'Correction',
                value: 'Correction'
            },
            {
                text: 'Rejected',
                value: 'Rejected'
            },
            {
                text: 'Failed',
                value: 'Failed'
            }
        ]
    }

    processEAppHistory(model: BeneficiarySoaDetail[]) {
        if (model.length === 0) {
            this.IsrecordFound = true
            this.serviceResponse = 'No Record Found'
            this.loading = false
        } else {
            model.map((row) => {
                row.RecCreateTS = moment(row.RecCreateTS).format('MM/DD/YYYY hh:mm A')
            })
            this.beneficiarySOAViewModel = model
            this.beneficiarySOAViewModel.forEach((recDate) => {
                if (recDate.RecCreateTS !== null) {
                    recDate.RecCreateTS = moment(recDate.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A').toString()
                }
            })
            this.IsrecordFound = false
            this.totalCount = this.source.totalrecords = this.beneficiarySOAViewModel[0].TotalCount
            this.source.localdata = this.beneficiarySOAViewModel

            this.dataAdapter.dataBind()
            this.myGrid.updatebounddata()
            this.loading = false
            this.skipCall = false
        }
    }

    showHideAgentID() {
        if (
            this._global.currentUser.IsGuruAdmin ||
            this._global.currentUser.IsSuperAdminAdmin ||
            this._global.currentUser.IsSuperAdminSMA ||
            this._global.currentUser.IsSuperAdminSMM ||
            this._global.currentUser.isOrganizationalManager ||
            this._global.currentUser.isOrganizationalAdmin ||
            this._global.currentUser.IsAdminOrAgent
        ) {
            this.showAgentID = true
        } else {
            this.showAgentID = false
        }
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse
        }

        this.order = value
    }
    constructor(
        private excelService: ExcelService,
        private enrollementGateway: EnrollmentGateway,
        private router: Router,
        private _networkUserAccessGateway: UserAccessGateway,
        public _global: PortalGlobals
    ) {
        ;(this.excelService = excelService), (this.jqxGridVirtualPaging = new JqxGridVirtualPaging())
    }

    // calls when exportToExcel is clicked
    exportToExcel() {
        this.searchInsertModel.PageNumber = 1
        this.searchInsertModel.PageSize = this.totalCount
        if (this.currentUser.AetnaInd === true) {
            this.enrollementGateway.getPWEAppHistoryForExport(this.searchInsertModel).subscribe((model: ExportHistoryModel[]) => {
                this.processEAppHistoryExportData(model)
            })
        } else {
            this.enrollementGateway.getEAppHistoryForExport(this.searchInsertModel).subscribe((model: ExportHistoryModel[]) => {
                this.processEAppHistoryExportData(model)
            })
        }
    }

    processEAppHistoryExportData(model: ExportHistoryModel[]) {
        let summary: ExportHistoryModel[] = [] as ExportHistoryModel[]
        summary = model
        let array = _.clone(summary)
        let strArray = JSON.stringify(array)
        strArray = strArray.replace(/BeneficiaryName/g, 'Beneficiary Name')
        strArray = strArray.replace(/BeneficiaryEmail/g, 'Beneficiary Email')
        strArray = strArray.replace(/DateCreated/g, 'Date Created')
        strArray = strArray.replace(/PlanYear/g, 'Plan Year')
        strArray = strArray.replace(/ApplicationStatus/g, 'Status')
        strArray = strArray.replace(/AgentID/g, 'Agent ID')
        strArray = strArray.replace(/ConfirmationNumber/g, 'Confirmation #')

        this.exportSOA = JSON.parse(strArray)

        if (this.exportSOA.length === 0) {
            this.IsrecordFound = true
            this.serviceResponse = 'No Record Found'
        } else {
            this.excelService.exportAsExcelFile(this.exportSOA, 'BeneficiaryReport')
            this.IsrecordFound = false
        }
    }

    CellclickOnEdit(event: any): void {
        if (event.args.column.text === '') {
            let pdf = event.args.row.bounddata.EnrollmentPdf
            if (pdf.length > 0) {
                this.downloadError = ''
                let downloadDetail = {} as BeneficiarySoaDetail
                downloadDetail.EnrollmentPdf = pdf
                this.downloadPDF(downloadDetail)
            } else {
                this.downloadError = 'File Not Found'
            }
        }

        if (
            event.args.column.text === 'Status' &&
            (event.args.value === 'In Progress' || event.args.value === 'Failed' || event.args.value === 'Correction')
        ) {
            let uniqueLink = event.args.row.bounddata.UniqueLink
            let applicationStatus = event.args.row.bounddata.ApplicationStatus
            this.redirectlink(uniqueLink, applicationStatus)
        }
    }

    // downloads PDF
    downloadPDF(beneficiarysoadetail: BeneficiarySoaDetail) {
        this.loading = true
        this.downloadError = ''
        this.enrollementGateway.streamPDF(beneficiarysoadetail.EnrollmentPdf).subscribe(
            (res) => {
                this.loading = false
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    ;(window.navigator as any).msSaveOrOpenBlob(new Blob([res], { type: 'application/pdf' }), beneficiarysoadetail.EnrollmentPdf)
                }
                var url = window.URL.createObjectURL(res)
                var a = document.createElement('a')
                document.body.appendChild(a)
                a.setAttribute('style', 'display: none')
                a.href = url
                a.download = beneficiarysoadetail.EnrollmentPdf
                a.click()
                window.URL.revokeObjectURL(url)
                a.remove()
            },
            (error) => {
                this.loading = false
                this.downloadError = 'File Not Found'
                console.log('download error:', JSON.stringify(error))
            },
            () => {
                this.loading = false
                console.log('Completed file download.')
            }
        )
        //console.log('User clicked on download pdf button' + beneficiarysoadetail.EnrollmentPdf)
        //this.enrollementGateway.downloadPDF(beneficiarysoadetail.EnrollmentPdf).subscribe(
        //    (model: any) => {
        //        //base64 To ArrayBuffer
        //        var binaryString = window.atob(model);
        //        var binaryLen = binaryString.length;
        //        console.log('binaryLen' + binaryLen)
        //        if (binaryLen == 3) {
        //            console.log('File doesnt exist / some back ground  error')
        //            this.downloadError = 'File Not Found'
        //            return;
        //        }
        //        this.downloadError = ''
        //        var bytes = new Uint8Array(binaryLen);
        //        for (var i = 0; i < binaryLen; i++) {
        //            var ascii = binaryString.charCodeAt(i);
        //            bytes[i] = ascii;
        //        }

        //        let fileName = beneficiarysoadetail.EnrollmentPdf
        //        // below code needed for ie browser
        //        if (window.navigator && window.navigator.msSaveOrOpenBlob) {

        //            console.log('user clickedon ie browser')
        //            window.navigator.msSaveOrOpenBlob(new Blob([bytes],
        //                { type: 'application/pdf' }), fileName)
        //        }
        //        // for other browsers
        //        var link = document.createElement('a')
        //        link.href = URL.createObjectURL(new Blob([bytes]));
        //        link.download = fileName;
        //        document.body.appendChild(link);
        //        link.click();
        //        // Revoking is tricky
        //        // https://code.google.com/p/chromium/issues/detail?id=375297#c7
        //        window.setTimeout(function () {
        //            URL.revokeObjectURL(link.href);
        //            document.body.removeChild(link);
        //        }, 100);
        //    })
    }

    // calls when user clicks on search
    searcheAppHistoryData(searchInsertModel: SearchInsertModel) {
        this.IsrecordFound = false
        this.loading = true
        this.searchInsertModel.PageNumber = 1
        if (this.searchInsertModel.PageSize === null) {
            this.searchInsertModel.PageSize = 20
        }
        this.searchInsertModel.FilterCriteria = ''
        this.searchInsertModel.SortFields = ''
        if (this.myGrid !== null && this.myGrid !== undefined) {
            //Workaround to stop triggering of OnFilter and OnSort event, when filters and sort are cleared
            this.skipCall = true
            this.myGrid.clearfilters()
            this.myGrid.removesort()
        }
        if (this.currentUser.AetnaInd === true) {
            this.enrollementGateway.searchPWeAppHistoryData(searchInsertModel).subscribe(
                (model: BeneficiarySoaDetail[]) => {
                    this.processeAppSearchResults(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.enrollementGateway.searcheAppHistoryData(searchInsertModel).subscribe(
                (model: BeneficiarySoaDetail[]) => {
                    this.processeAppSearchResults(model)
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    processeAppSearchResults(model: BeneficiarySoaDetail[]) {
        model.map((row) => {
            row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
        })
        this.beneficiarySOAViewModel = model
        if (model.length === 0) {
            this.source.localdata = ''
            this.dataAdapter.dataBind()
            this.myGrid.updatebounddata()
            this.IsrecordFound = true
            this.serviceResponse = 'No Record Found'
            this.loading = false
            this.skipCall = false
        } else {
            this.IsrecordFound = false
            this.source.totalrecords = this.beneficiarySOAViewModel[0].TotalCount
            this.source.localdata = this.beneficiarySOAViewModel

            this.dataAdapter.dataBind()
            this.myGrid.updatebounddata()
            this.loading = false
            this.skipCall = false
        }
    }

    newApplication() {
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate([insCo + '/enrollment/e-app-info1'])
    }

    redirectlink(uniqueLink, status) {
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate([insCo + '/enrollment/e-app/' + uniqueLink + '/' + status])
    }

    rendergridrows = (params: any): any[] | undefined => {
        if (!isNaN(params.startindex)) {
            this.searchInsertModel.PageNumber = Math.floor(params.startindex / this.searchInsertModel.PageSize) + 1
            if (!this.skipCall) {
                this.loading = true
                this.beneficiarySOAViewModel = this.enrollementGateway.loadBSOADataSync(this.searchInsertModel)
                this.beneficiarySOAViewModel.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
                this.loading = false
            }
            return this.beneficiarySOAViewModel
        }
    }

    ready = (): void => {
        this.myGrid.localizestrings(this.jqxGridVirtualPaging.ready())
    }

    onFilter(event: any): void {
        if (!this.skipCall) {
            this.loading = true
            this.skipCall = true
            let filterinfo = this.myGrid.getfilterinformation()

            this.searchInsertModel.FilterCriteria = this.jqxGridVirtualPaging.onFilter(event, filterinfo)
            let summary = this.enrollementGateway.loadBSOADataSync(this.searchInsertModel)
            if (summary !== null || summary !== undefined) {
                summary.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
                this.beneficiarySOAViewModel = summary
                this.source.localdate = summary
                this.source.totalrecords = summary[0].TotalCount

                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
            }
            this.skipCall = false
        }
    }

    onSort(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            this.loading = true
            this.searchInsertModel.SortFields = this.jqxGridVirtualPaging.onSort(event)
            let summary = this.enrollementGateway.loadBSOADataSync(this.searchInsertModel)
            if (summary !== null || summary !== undefined) {
                summary.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
                this.beneficiarySOAViewModel = summary
                this.source.localdate = summary
                this.source.totalrecords = summary[0].TotalCount
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
            }
            this.skipCall = false
        }
    }

    onPageSizeChanged(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            this.loading = true
            let args = event.args
            this.source.pagesize = this.searchInsertModel.PageSize = args.pagesize
            let summary = this.enrollementGateway.loadBSOADataSync(this.searchInsertModel)
            if (summary !== null || summary !== undefined) {
                summary.map((row) => {
                    row.RecCreateTS = moment(row.RecCreateTS).subtract(7, 'h').format('MM/DD/YYYY hh:mm A')
                })
                this.beneficiarySOAViewModel = summary
                this.source.localdate = summary
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
            }
            this.skipCall = false
        }
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxGridVirtualPaging.updatefilterconditions(type)
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.searcheAppHistoryData(this.searchInsertModel)
        }
    }
}
